/**
 * 霍兰德职业兴趣测试 - 类型数据
 * 
 * 基于John Holland的RIASEC理论
 * 包含6种职业兴趣类型的完整信息
 */

// 完整的六种类型数据
export const HOLLAND_TYPES = {
  R: {
    code: 'R',
    name: '实际型',
    nameEn: 'Realistic',
    fullName: '实际型(Realistic)',
    emoji: '🔧',
    color: '#10b981',       // 绿色
    bgColor: '#ecfdf5',
    gradient: 'linear-gradient(135deg, #10b981, #14b8a6)',
    
    // 基本描述
    description: '喜欢使用工具、机器，进行实际操作。倾向于从事需要动手能力、体力或技能的工作。',
    
    // 工作风格
    workStyle: '注重实际成果，喜欢具体可见的工作任务。',
    
    // 性格特质
    traits: ['务实', '坦率', '诚实', '谦逊', '动手能力强', '喜欢户外'],
    
    // 适合职业 (简短列表)
    suitable: '工程师、技师、建筑工人、机械操作员、农民、电工',
    
    // 核心优势
    strengths: [
      '擅长使用工具和机械设备',
      '具有很强的动手能力和实践技能',
      '能够独立完成具体的技术任务',
      '在户外和实际操作环境中表现出色'
    ],
    
    // 潜在挑战
    challenges: [
      '可能不善于处理抽象概念和理论问题',
      '在需要大量人际交往的环境中可能感到不适',
      '可能对艺术和创意表达缺乏兴趣',
      '在办公室环境中可能感到受限'
    ],
    
    // 学习风格
    learningStyle: '您更喜欢通过实践和动手操作来学习。理论学习对您来说可能较为枯燥，但当能够实际应用时，您的学习效率会大大提高。建议多参与实验、实习和项目实践。',
    
    // 详细描述
    detailedDescription: '实际型的人通常务实、坦率，喜欢从事具体、有形的工作。他们善于使用工具、机器和设备，享受通过双手创造实际成果的过程。这类人往往对机械原理感兴趣，喜欢户外活动，倾向于选择能够看到直接成果的工作。他们可能不太喜欢处理抽象概念或理论问题，更倾向于通过实践来学习和理解新事物。',
    
    // 典型职业 (详细)
    typicalCareers: [
      {
        title: '机械工程师',
        description: '设计、开发和测试机械设备和系统，将工程原理应用于实际问题的解决。',
        education: '本科及以上（机械工程、机械设计等专业）',
        salary: '8k-20k/月'
      },
      {
        title: '电气工程师',
        description: '负责电气系统的设计、安装和维护，确保电力设备的正常运行。',
        education: '本科及以上（电气工程、自动化等专业）',
        salary: '7k-18k/月'
      },
      {
        title: '建筑施工管理',
        description: '协调建筑项目的实施，监督施工进度和质量，确保项目按时完成。',
        education: '专科及以上（建筑工程、工程管理等专业）',
        salary: '6k-15k/月'
      }
    ],
    
    // 专业推荐
    majors: [
      '工程技术类专业：机械、电气、土木等',
      '计算机硬件和网络技术',
      '农业、林业、园艺等实用学科',
      '汽车维修、机械操作等技能培训'
    ],
    
    // 发展建议
    developmentSuggestions: [
      '提升专业技术技能和操作能力',
      '学习相关工具和设备的使用',
      '培养问题诊断和解决能力',
      '关注新技术和新工艺的发展'
    ],
    
    // 发展路径
    developmentPath: {
      shortTerm: [
        '掌握本专业的核心技能和工具',
        '获取相关技术证书和资格认证',
        '积累实际项目经验',
        '学习行业最新技术和标准'
      ],
      longTerm: [
        '成为领域内的技术专家',
        '考虑向技术管理方向发展',
        '持续关注行业技术革新',
        '建立个人技术品牌和影响力'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择技术含量高的岗位，在实践中不断精进专业技能',
      '考虑进入制造业、建筑业、工程类企业等实操性强的行业',
      '注重积累实际项目经验，建立自己的作品集或项目案例',
      '保持对新技术、新工艺的学习热情，提升技术竞争力',
      '可以考虑考取相关专业资格证书，增强职业认可度'
    ]
  },
  
  I: {
    code: 'I',
    name: '研究型',
    nameEn: 'Investigative',
    fullName: '研究型(Investigative)',
    emoji: '🔬',
    color: '#6366f1',
    bgColor: '#eef2ff',
    gradient: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    description: '喜欢观察、学习、研究、分析问题。倾向于从事需要思考、分析和探索的工作。',
    workStyle: '善于独立思考，喜欢通过逻辑分析解决问题。',
    traits: ['理性', '好奇', '独立', '精确', '善于分析', '逻辑思维强'],
    suitable: '科学家、研究员、医生、程序员、数据分析师、实验室技术员',
    strengths: [
      '具有强大的分析和逻辑思维能力',
      '善于独立研究和探索未知领域',
      '对知识有强烈的好奇心和求知欲',
      '能够处理复杂的抽象概念'
    ],
    challenges: [
      '可能过于注重理论而忽视实践应用',
      '在需要快速决策的情况下可能犹豫不决',
      '可能不太善于处理人际关系',
      '有时可能过于追求完美而影响效率'
    ],
    learningStyle: '您喜欢深入研究和理解事物的本质。通过阅读、思考和实验来学习对您最有效。您可能需要时间来消化新知识，但一旦理解就能融会贯通。',
    detailedDescription: '研究型的人通常理性、好奇，对知识有强烈的追求。他们善于观察、学习、研究和分析，喜欢通过逻辑推理来解决问题。这类人往往具有独立思考的能力，对科学、技术和学术研究感兴趣。他们可能更喜欢独立工作，在安静的环境中进行深度思考。',
    typicalCareers: [
      {
        title: '数据科学家',
        description: '运用统计分析和机器学习技术，从数据中挖掘有价值的信息和洞察。',
        education: '硕士及以上（数据科学、统计学、计算机科学等专业）',
        salary: '15k-40k/月'
      },
      {
        title: '医学研究员',
        description: '进行医学相关的科学研究，推动医疗技术和治疗方法的进步。',
        education: '博士（医学、生物学等专业）',
        salary: '10k-30k/月'
      },
      {
        title: '软件工程师',
        description: '设计和开发软件系统，解决技术问题，优化代码性能。',
        education: '本科及以上（计算机科学、软件工程等专业）',
        salary: '10k-35k/月'
      }
    ],
    majors: [
      '自然科学类专业：物理、化学、生物等',
      '医学、药学等健康科学',
      '计算机科学、数据科学、统计学',
      '心理学、社会学等研究性学科'
    ],
    developmentSuggestions: [
      '加强逻辑思维和分析能力',
      '提升数据处理和统计分析技能',
      '培养科学研究方法和实验设计能力',
      '保持好奇心，持续学习新知识'
    ],
    developmentPath: {
      shortTerm: [
        '深入学习专业领域的理论知识',
        '参与科研项目，积累研究经验',
        '学习数据分析和科研工具',
        '培养批判性思维和问题解决能力'
      ],
      longTerm: [
        '在专业领域发表研究成果',
        '成为行业内的专家或学者',
        '考虑攻读更高学位',
        '参与重大科研项目或创新研究'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择科研机构、高校、实验室等重视研究和分析的工作环境',
      '在职业早期注重学历和专业知识的积累，考虑攻读硕士或博士学位',
      '培养系统性思维和科学研究方法，建立自己的研究方向',
      '多参与学术交流和项目合作，扩展专业视野',
      '平衡理论研究与实践应用，让研究成果产生实际价值'
    ]
  },
  
  A: {
    code: 'A',
    name: '艺术型',
    nameEn: 'Artistic',
    fullName: '艺术型(Artistic)',
    emoji: '🎨',
    color: '#ec4899',
    bgColor: '#fdf2f8',
    gradient: 'linear-gradient(135deg, #ec4899, #f472b6)',
    description: '喜欢创作、设计、表演等艺术活动。倾向于从事需要创造力和想象力的工作。',
    workStyle: '追求创新和自我表达，喜欢非结构化的工作方式。',
    traits: ['创造', '感性', '直觉', '独立', '想象力丰富', '追求美感'],
    suitable: '艺术家、设计师、作家、音乐家、摄影师、导演',
    strengths: [
      '拥有丰富的创造力和想象力',
      '善于通过艺术形式表达情感和思想',
      '对美和艺术有敏锐的感知能力',
      '能够以独特的视角看待世界'
    ],
    challenges: [
      '可能不太适应严格的规则和程序',
      '在需要精确计算或逻辑分析时可能感到困难',
      '收入可能不太稳定，尤其在职业初期',
      '可能过于感性而忽视实际问题'
    ],
    learningStyle: '您通过体验、观察和创作来学习效果最好。传统的课堂教学可能让您感到拘束，而实际创作和项目式学习更能激发您的潜能。',
    detailedDescription: '艺术型的人通常富有创造力，喜欢通过艺术形式表达自己。他们对美有敏锐的感知，善于用独特的方式看待世界。这类人往往感性、直觉，喜欢自由和非结构化的工作环境。他们可能不太喜欢遵循严格的规则，更倾向于创新和突破常规。',
    typicalCareers: [
      {
        title: 'UI/UX设计师',
        description: '设计用户界面和用户体验，创造美观且易用的数字产品。',
        education: '本科及以上（设计、艺术等专业）',
        salary: '8k-25k/月'
      },
      {
        title: '创意文案',
        description: '撰写富有创意的广告文案和营销内容，吸引目标受众。',
        education: '本科及以上（中文、新闻、广告等专业）',
        salary: '6k-20k/月'
      },
      {
        title: '视频制作人',
        description: '策划和制作视频内容，包括拍摄、剪辑和后期制作。',
        education: '专科及以上（影视制作、传媒等专业）',
        salary: '7k-22k/月'
      }
    ],
    majors: [
      '艺术设计类专业：美术、设计、音乐等',
      '文学、新闻、传媒等创作类学科',
      '建筑学、风景园林等艺术性专业',
      '戏剧影视、动画等表演艺术'
    ],
    developmentSuggestions: [
      '培养创造力和想象力',
      '提升审美能力和艺术修养',
      '学习设计软件和创作工具',
      '多观察、多体验、多创作'
    ],
    developmentPath: {
      shortTerm: [
        '建立个人作品集',
        '学习和精通创作工具',
        '参与艺术项目和展览',
        '培养独特的艺术风格'
      ],
      longTerm: [
        '成为领域内有影响力的艺术家或设计师',
        '举办个人展览或发布个人作品',
        '考虑跨领域合作和创新',
        '建立个人品牌和艺术事业'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择创意产业和文化艺术领域，如设计公司、广告公司、影视传媒等',
      '建立个人作品集和品牌，通过作品展示个人风格和创造力',
      '保持对艺术和设计趋势的敏感度，不断创新和突破',
      '考虑自由职业或创业，给自己更多的创作自由',
      '在追求艺术理想的同时，也要关注作品的商业价值和市场需求'
    ]
  },
  
  S: {
    code: 'S',
    name: '社会型',
    nameEn: 'Social',
    fullName: '社会型(Social)',
    emoji: '🤝',
    color: '#f59e0b',
    bgColor: '#fffbeb',
    gradient: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
    description: '喜欢与人交往、帮助他人、服务社会。倾向于从事需要人际互动和服务的工作。',
    workStyle: '重视人际关系，善于团队合作和沟通。',
    traits: ['友善', '热情', '负责', '善解人意', '乐于助人', '同理心强'],
    suitable: '教师、护士、心理咨询师、社工、人力资源、客服',
    strengths: [
      '具有出色的沟通和人际交往能力',
      '善于理解他人的情感和需求',
      '能够建立和维护良好的人际关系',
      '在团队合作中表现出色'
    ],
    challenges: [
      '可能过于关注他人而忽视自己的需求',
      '在需要做出困难决定时可能犹豫不决',
      '可能不太适应高度竞争的环境',
      '情绪容易受他人影响'
    ],
    learningStyle: '您通过互动和讨论学习效果最好。小组学习、案例讨论和角色扮演等方式能帮助您更好地理解和掌握知识。',
    detailedDescription: '社会型的人通常友善、热情，喜欢与人交往和帮助他人。他们善于理解他人的情感和需求，具有很强的同理心。这类人往往乐于助人，倾向于选择能够为社会做贡献的工作。他们在需要人际互动和团队合作的环境中表现出色。',
    typicalCareers: [
      {
        title: '心理咨询师',
        description: '提供心理咨询服务，帮助来访者解决心理问题，促进心理健康。',
        education: '硕士及以上（心理学、应用心理学等专业）+ 资格证书',
        salary: '8k-30k/月'
      },
      {
        title: '人力资源专员',
        description: '负责招聘、培训、员工关系等HR工作，促进组织和员工发展。',
        education: '本科及以上（人力资源、工商管理等专业）',
        salary: '6k-18k/月'
      },
      {
        title: '中学教师',
        description: '教授学科知识，引导学生成长，培养下一代人才。',
        education: '本科及以上（师范类专业）+ 教师资格证',
        salary: '5k-15k/月'
      }
    ],
    majors: [
      '教育学、学前教育、特殊教育',
      '临床医学、护理学、康复治疗',
      '心理学、社会工作、社会学',
      '人力资源管理、行政管理'
    ],
    developmentSuggestions: [
      '提升沟通和人际交往能力',
      '培养同理心和情绪管理能力',
      '学习团队协作和冲突解决技巧',
      '增强服务意识和责任感'
    ],
    developmentPath: {
      shortTerm: [
        '提升专业服务技能',
        '获取相关资格证书',
        '积累人际沟通经验',
        '学习心理学和沟通技巧'
      ],
      longTerm: [
        '成为领域内的资深专家',
        '考虑管理或咨询方向发展',
        '建立专业服务口碑',
        '为更多人提供帮助和支持'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择教育、医疗、社会服务等以人为本的行业和岗位',
      '注重培养沟通能力、同理心和情绪管理能力',
      '考虑考取相关专业资格证书，如教师资格证、心理咨询师证等',
      '在工作中建立良好的人际关系网络，积累专业口碑',
      '保持服务热情的同时，也要学会照顾好自己的身心健康'
    ]
  },
  
  E: {
    code: 'E',
    name: '企业型',
    nameEn: 'Enterprising',
    fullName: '企业型(Enterprising)',
    emoji: '💼',
    color: '#ef4444',
    bgColor: '#fef2f2',
    gradient: 'linear-gradient(135deg, #ef4444, #f87171)',
    description: '喜欢影响他人、组织管理、追求成就。倾向于从事需要领导和管理能力的工作。',
    workStyle: '目标导向，善于说服和影响他人。',
    traits: ['自信', '有野心', '说服力强', '精力充沛', '领导力', '冒险精神'],
    suitable: '企业家、经理、销售、律师、政治家、市场营销',
    strengths: [
      '具有很强的领导力和影响力',
      '善于说服他人并推动目标实现',
      '勇于承担风险和挑战',
      '能够在压力下做出决策'
    ],
    challenges: [
      '可能过于关注结果而忽视过程',
      '有时可能显得过于强势或霸道',
      '可能不太善于处理细节工作',
      '在失败时可能难以接受'
    ],
    learningStyle: '您通过实践和挑战学习效果最好。模拟商业案例、团队项目和实际管理经验能帮助您快速成长。',
    detailedDescription: '企业型的人通常自信、有野心，喜欢影响他人和追求成就。他们善于组织管理，具有很强的领导力和说服力。这类人往往精力充沛，勇于承担风险和挑战，倾向于选择能够展现个人能力和实现目标的工作。他们在竞争性和目标导向的环境中表现出色。',
    typicalCareers: [
      {
        title: '销售经理',
        description: '领导销售团队，制定销售策略，实现业绩目标。',
        education: '本科及以上（市场营销、工商管理等专业）',
        salary: '10k-40k/月（含提成）'
      },
      {
        title: '创业者',
        description: '创建和运营自己的企业，承担商业风险，追求创新和增长。',
        education: '不限（商业经验更重要）',
        salary: '收入不定，取决于企业发展'
      },
      {
        title: '项目经理',
        description: '规划和执行项目，协调资源，确保项目按时按质完成。',
        education: '本科及以上（工商管理、工程管理等专业）+ PMP证书',
        salary: '12k-30k/月'
      }
    ],
    majors: [
      '工商管理、市场营销、国际商务',
      '法学、政治学、公共管理',
      '金融学、投资学、保险学',
      '创业管理、战略管理'
    ],
    developmentSuggestions: [
      '提升领导力和团队管理能力',
      '培养商业思维和战略规划能力',
      '增强说服力和谈判技巧',
      '学习目标设定和执行能力'
    ],
    developmentPath: {
      shortTerm: [
        '积累管理和领导经验',
        '提升商业分析能力',
        '建立专业人脉网络',
        '学习财务和战略知识'
      ],
      longTerm: [
        '晋升到高级管理岗位',
        '考虑创业或投资机会',
        '成为行业领袖或意见领袖',
        '实现个人事业目标和愿景'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择商业、管理、销售等目标导向和竞争性强的领域',
      '主动争取领导和管理机会，在实践中提升领导力',
      '建立广泛的人脉网络，学会借助他人的力量达成目标',
      '培养商业思维和战略眼光，关注市场趋势和商业机会',
      '在追求成功的同时，也要注重团队合作和长期发展'
    ]
  },
  
  C: {
    code: 'C',
    name: '传统型',
    nameEn: 'Conventional',
    fullName: '传统型(Conventional)',
    emoji: '📊',
    color: '#3b82f6',
    bgColor: '#eff6ff',
    gradient: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
    description: '喜欢有规则的、系统化的工作。倾向于从事需要精确性和规范性的工作。',
    workStyle: '注重细节和准确性，善于执行既定流程。',
    traits: ['细心', '有条理', '忠诚', '保守', '追求稳定', '注重细节'],
    suitable: '会计、秘书、银行职员、档案管理员、行政人员、审计师',
    strengths: [
      '具有很强的组织和规划能力',
      '注重细节，工作精确可靠',
      '善于遵循流程和规范',
      '在稳定的环境中表现出色'
    ],
    challenges: [
      '可能不太善于应对突发情况和变化',
      '在需要创新或突破常规时可能感到困难',
      '可能过于追求完美而影响效率',
      '在高度不确定的环境中可能感到不适'
    ],
    learningStyle: '您通过系统化的学习和重复练习掌握知识效果最好。清晰的结构、详细的步骤和充分的练习能帮助您扎实掌握技能。',
    detailedDescription: '传统型的人通常细心、有条理，喜欢有规则和系统化的工作。他们注重细节和准确性，善于执行既定的流程和规范。这类人往往忠诚、保守，倾向于选择稳定和可预测的工作环境。他们在需要精确性和规范性的岗位上表现出色。',
    typicalCareers: [
      {
        title: '财务会计',
        description: '负责财务记录、报表编制和税务申报等工作，确保财务数据准确。',
        education: '本科及以上（会计学、财务管理等专业）+ 会计证书',
        salary: '6k-20k/月'
      },
      {
        title: '行政专员',
        description: '处理日常行政事务，协调部门工作，确保办公环境高效运转。',
        education: '专科及以上（行政管理、工商管理等专业）',
        salary: '4k-10k/月'
      },
      {
        title: '数据录入员',
        description: '准确录入和管理数据，维护数据库，确保信息完整性。',
        education: '高中及以上',
        salary: '3k-8k/月'
      }
    ],
    majors: [
      '会计学、审计学、财务管理',
      '档案学、图书馆学、信息管理',
      '行政管理、公共事业管理',
      '统计学、经济学、金融学'
    ],
    developmentSuggestions: [
      '提升细节处理和数据管理能力',
      '培养组织规划和流程优化能力',
      '学习办公软件和管理工具',
      '增强执行力和时间管理能力'
    ],
    developmentPath: {
      shortTerm: [
        '精通专业软件和工具',
        '获取专业资格证书',
        '提升数据分析能力',
        '培养流程优化意识'
      ],
      longTerm: [
        '成为领域内的专家',
        '考虑向管理方向发展',
        '建立系统化的工作方法论',
        '为组织提供稳定可靠的支持'
      ]
    },
    
    // 职业发展建议
    careerAdvice: [
      '选择金融、会计、行政等注重规范和稳定的行业和岗位',
      '注重细节和准确性，建立可靠专业的工作形象',
      '考虑考取专业资格证书，如会计证、审计师等',
      '培养数据分析和流程优化能力，提升工作效率',
      '在保持稳定的同时，也要适当拓展思维，适应变化'
    ]
  }
};

// Holland Code组合解读生成器
export const HOLLAND_CODE_COMBINATIONS = {
  // 生成Holland Code组合解读
  generateInterpretation(code) {
    const primary = HOLLAND_TYPES[code[0]];
    const secondary = HOLLAND_TYPES[code[1]];
    const tertiary = HOLLAND_TYPES[code[2]];
    
    return `您的Holland Code是${code}，这代表您在${primary.name}、${secondary.name}和${tertiary.name}这三个方面的兴趣最为突出。

${primary.name}作为您的主导类型，意味着您${primary.description}这是您职业选择的核心方向。

${secondary.name}作为您的次要类型，为您的职业发展提供了补充视角。${secondary.description}

${tertiary.name}作为您的第三类型，进一步丰富了您的职业兴趣组合。${tertiary.description}

这三种类型的结合，使您在${primary.name}+${secondary.name}的领域中可能有独特的优势。建议您在职业选择时，优先考虑能够同时发挥这三种兴趣的职业方向。`;
  }
};

// 获取类型等级描述
export function getTypeLevel(percentage) {
  if (percentage >= 80) return '非常高';
  if (percentage >= 60) return '高';
  if (percentage >= 40) return '中等';
  if (percentage >= 20) return '较低';
  return '低';
}

// 获取类型完整信息
export function getTypeInfo(typeCode) {
  return HOLLAND_TYPES[typeCode] || null;
}

// 获取类型名称
export function getTypeName(typeCode) {
  return HOLLAND_TYPES[typeCode]?.name || '未知类型';
}

// 获取类型颜色
export function getTypeColor(typeCode) {
  return HOLLAND_TYPES[typeCode]?.color || '#gray';
}

// 获取所有类型代码
export function getAllTypeCodes() {
  return Object.keys(HOLLAND_TYPES);
}

